import TableList from "@components/templates/tablelist";
import { HttpRuleList, HttpCopyRule, HttpDelRule } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin'
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },

    methods: {
        ajaxRequest: HttpRuleList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "carrierUpdateRule",
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "carrierUpdateRule",
                        params: { type: "edit" },
                        query: { id: params }
                    });
                    break;
                case "query":
                    {
                        let url = this.$router.resolve({
                            name: "carrierUpdateRule",
                            params: { type: "query" },
                            query: { id: params }
                        });
                        window.open(url.href, "_blank");
                    }
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                        ajaxRequest: HttpDelRule
                    };
                    break;
                case "copy":
                    this.operate = {
                        width: 500,
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.carrier.extra_copy', { defaultValue: '规则复制' }),
                        ajaxRequest: HttpCopyRule,
                        showDesc: false,
                        formdata: [{
                            label: this.$t('fbb.carrier.extra_source_service', { defaultValue: '来源承运商服务' }),
                            tag: 'vSelect',
                            key: "sourceCarrierId",
                            span: 24,
                            // options: this.getCarrierServiceOpt,
                            options: this.getCarrierServiceAllList,
                            props: {
                                filterable: true
                            },
                        }, {
                            label: this.$t('fbb.carrier.targetCarrierId', { defaultValue: '目标承运商服务' }),
                            tag: 'vSelect',
                            key: "targetCarrierId",
                            span: 24,
                            // options: this.getCarrierServiceOpt,
                            options: this.getCarrierServiceAllList,
                            props: {
                                filterable: true
                            },
                        }, {
                            query: true,
                            formItem: {
                                labelWidth: 60
                            },
                            span: 24,
                            valueText: '<div class="color-error">'+this.$t('fbb.carrier.targetCarrierId_tip', { defaultValue: '确认复制后，目标承运商服务原限制规则会被清除，请谨慎操作!' })+'</div>'
                        }]
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row;
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    params: id,
                    show: true,
                    operate: "edit"
                },
                {
                    label: this.$t('global.common.delete', { defaultValue: '删除' }),
                    params: id,
                    show: true,
                    operate: "del"
                }
            ];
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    theme: "primary"
                },
                {
                    name: this.$t('fbb.carrier.extra_copy', { defaultValue: '规则复制' }),
                    operate: "copy",
                    theme: "info"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    // label: this.$t('fbb.alloment.carrier_server', { defaultValue: '承运商服务' }),
                    label: "承运商服务",
                    tag: "vSelect",
                    key: "EQ_systemCarrierServiceId",
                    show: true,
                    props: {
                        filterable: true
                    },
                    // options: this.getCarrierServiceOpt
                    options: this.getCarrierServiceAllList,
                }
            ];
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.carrier_server', { defaultValue: '承运商服务' }),
                    key: "carrierServiceCode",
                    template: "{carrierServiceCode}({carrierServiceName})",
                    sortable: true,
                },
                {
                    title: this.$t('fbb.carrier.ruleLabel', { defaultValue: '规则标识' }),
                    key: "ruleLabel",
                    sortable: true,
                    render: (h, { row }) => this.findRenderLabel(this.getRulelabelOpt, row.ruleLabel)//this.findRenderLabel 查看tablelist 组件
                },
                {
                    title: this.$t('fbb.carrier.ruleRangeType', { defaultValue: '规则匹配类型' }),
                    key: "ruleRangeType",
                    sortable: true,
                    render: (h, { row }) => this.findRenderLabel(this.getRuleTypeOpt, row.ruleRangeType)//this.findRenderLabel 查看tablelist 组件

                },
                {
                    title: this.$t('fbb.carrier.ruleRangeMin', { defaultValue: '最小值' }),
                    key: "ruleRangeMin"
                },
                {
                    title: this.$t('fbb.carrier.ruleRangeMax', { defaultValue: '最大值' }),
                    key: "ruleRangeMax"
                },
                {
                    title: this.$t('fbb.carrier.ruleRangeFormula', { defaultValue: '匹配公式' }),
                    key: "ruleRangeFormula"
                },
                {
                    title: this.$t('fbb.carrier.extra_rule_remark', { defaultValue: '规则描述' }),
                    key: "remark"
                }
            ];
        }
    }
};
